import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { I18nService } from '@eui/core';
import { BasicDialogComponent } from '@shared/components/dialogs/basic-dialog.component';

@Component({
    standalone: false,
    selector: 'app-terms-and-conditions-dialog',
    templateUrl: './terms-and-conditions-dialog.component.html'
})
export class TermsAndConditionsDialogComponent extends BasicDialogComponent implements OnInit {

    currentLanguage$: Observable<string>;

    constructor(private i18nService: I18nService) {
        super();
    }

    ngOnInit() {
        this.currentLanguage$ = this.i18nService.getState('activeLang');
    }
}
